// extracted by mini-css-extract-plugin
export default {"hover__card":"educationcard_hover__card__Ku-O0","honey__hover":"educationcard_honey__hover__5mVUS","subdegree":"educationcard_subdegree__z3S1B","icons":"educationcard_icons__EznTh"};